import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

// The order's HL7 documents, from the generic Healthlink message viewer that referrals
// already use — it answers for a lab order's control id as of KIN-1535.
//
// Returns:
//   xmlContent           the OML_O21 template we sent
//   xmlRetrievedContent  the completed order Healthlink assembled from the GP's
//                        Integrated Browser session, once downloaded — the only place
//                        the requested tests appear
//   xmlResponses         the hospital's ORL_O22 acknowledgement(s)
//
// No xslContent: Healthlink publishes no stylesheet for this message family, so the
// preview supplies our own (utils/labOrderMessageXsl).
export const useLabOrderXml = (messageControlId) => {
  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useQuery({
    queryKey: ["labOrderXml", messageControlId, tenantVal],
    queryFn: async () => {
      const axiosInstance = createAxiosInstance();

      try {
        const response = await axiosInstance.get(
          `${tenantVal}/healthlink/messages/${messageControlId}/xml`
        );

        return response?.data ?? null;
      } catch (error) {
        // A 404 is the normal answer for an order whose documents are not stored yet;
        // the preview shows its own empty state rather than an error.
        if (error?.response?.status === 404) return null;

        throw error;
      }
    },
    enabled: !!tenantVal && !!messageControlId,
    staleTime: 1000 * 60,
    meta: { skipGlobalError: true },
  });
};
